import { breakpoints } from './media'
import colors from './colors'

const createTheme = ({ centre }) => {
  const theme = {}
  return theme
}

export default createTheme
